export const SETLISTDATA = 'SETLISTDATA'
export const SETCOUNTRYLINKRESTRICTIONFLAG = 'SETCOUNTRYLINKRESTRICTIONFLAG'
export const SETTITLEDATA = 'SETTITLEDATA'
export const SETPHONEMESSAGEDATA = 'SETPHONEMESSAGEDATA'
export const SETSMSMESSAGEDATA = 'SETSMSMESSAGEDATA'
export const SETEMAILMESSAGEDATA = 'SETEMAILMESSAGEDATA'
export const SETCONTACTDATA = 'SETCONTACTDATA'
export const SETDELAYDATA = 'SETDELAYDATA'
export const SETNOTIFYDATA = 'SETNOTIFYDATA'
export const SETDISTANCEFLAGDATA = 'SETDISTANCEFLAGDATA'
export const SETDISTANCEDATA = 'SETDISTANCEDATA'
export const SETWORKERTYPESDATA = 'SETWORKERTYPESDATA'
export const SETLANGUAGEDATA = 'SETLANGUAGEDATA'
export const SETENGLISHPOSITIVERESPONSEDATA = 'SETENGLISHPOSITIVERESPONSEDATA'
export const SETENGLISHNEGATIVERESPONSEDATA = 'SETENGLISHNEGATIVERESPONSEDATA'
export const SETSPANISHPOSITIVERESPONSEDATA = 'SETSPANISHPOSITIVERESPONSEDATA'
export const SETSPANISHNEGATIVERESPONSEDATA = 'SETSPANISHNEGATIVERESPONSEDATA'
export const SETSCHEDULEDATA = 'SETSCHEDULEDATA'
export const SETCIDATA = 'SETCIDATA'
export const SETLISTINPUTDATA = 'SETLISTINPUTDATA'
export const SETLISTINPUTTYPE = 'SETLISTINPUTTYPE'
export const HOMEPAGECREATE = 'HOMEPAGECREATE'
export const HOMEPAGECREATEERROR = 'HOMEPAGECREATEERROR'
export const FETCH2 = 'FETCH2'
export const SELECTIONS = 'SELECTIONS'
